import Toast from '@roo/roo/Toast'

interface ToastWrapperFn {

  /**
   * @param message Toast 文案
   * @param duration Toast 展示时间，单位：ms，默认值 2000
   * @param extraProps 除 message, duration 之外 Toast 组件可接受的任何属性集合，[点此查看 Toast 全部 Props](https://roo.sankuai.com/roo/components/Toast#props)
   */
  (
    message: string,
    duration?: number,
    extraProps?: Partial<Omit<Parameters<typeof Toast.open>[0], 'messsage' | 'duration'>>,
  ): any;
}

const failToast: ToastWrapperFn = (message: string, duration = 2000, extraProps = {}) => Toast.open({
  duration,
  position: 'center',
  status: 'fail',
  theme: 'light',
  children: message,
  ...extraProps,
}) as any

const successToast: ToastWrapperFn = (message: string, duration = 2000, extraProps = {}) => Toast.open({
  duration,
  position: 'center',
  status: 'success',
  theme: 'light',
  children: message,
  ...extraProps,
}) as any
const warningToast: ToastWrapperFn = (message: string, duration = 2000, extraProps = {}) => Toast.open({
  duration,
  position: 'center',
  status: 'warning',
  theme: 'light',
  children: message,
  ...extraProps,
}) as any

const infoToast: ToastWrapperFn = (message: string, duration = 2000, extraProps = {}) => Toast.open({
  duration,
  position: 'center',
  status: 'info',
  theme: 'light',
  children: message,
  ...extraProps,
}) as any
const loadingToast: ToastWrapperFn = (message: string, duration = 2000, extraProps = {}) => Toast.open({
  duration,
  position: 'center',
  status: 'loading',
  theme: 'light',
  children: message,
  ...extraProps,
}) as any
export { failToast, successToast, warningToast, infoToast, loadingToast }
